"use client";
import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { withCmsDataHandling as P } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import W from "../../layout/Container/Container.js";
import { useViewportSize as j, Paper as z, Group as i, Link as s, Image as u, Paragraph as c, Heading as f, Button as g, sharedHandler as R } from "@ingeniorforeningen/figurine-core";
import { forwardRef as k, useState as A, useRef as B, useEffect as D } from "react";
import { spotboxDeliveryApiParser as F } from "./Spotbox.helpers.js";
import '../../../assets/Spotbox.css';const I = "_root_sit3d_2", L = "_contentWrapper_sit3d_14", V = "_textContent_sit3d_23", E = "_image_sit3d_44", a = {
  root: I,
  contentWrapper: L,
  textContent: V,
  image: E
}, d = k((x, w) => {
  const { image: r, button: t, header: l, content: p, subject: m, variant: h, ...C } = x, [y, _] = A(3), b = j(), o = B(null);
  return delete r?.caption, D(() => {
    if (!o.current)
      return;
    const v = o.current.offsetHeight, N = window.getComputedStyle(o.current).getPropertyValue("line-height"), S = parseInt(N, 10), H = Math.floor(v / S) > 1 ? 2 : 3;
    _(H);
  }, [b]), /* @__PURE__ */ e(W, { ...C, size: "md", children: /* @__PURE__ */ n(z, { className: a.root, ref: w, p: "sm", children: [
    /* @__PURE__ */ n(i, { direction: "column", wrap: "nowrap", hiddenFrom: "sm", spacing: "md", children: [
      r && /* @__PURE__ */ e(s, { href: t.href, target: t.target, children: /* @__PURE__ */ e(
        u,
        {
          ...r,
          caption: void 0,
          byline: void 0,
          orientation: "landscape",
          shadow: !0,
          className: a.image,
          sizes: "95vw"
        }
      ) }),
      /* @__PURE__ */ n(i, { direction: "column", spacing: "lg", className: a.textContent, children: [
        /* @__PURE__ */ e(
          c,
          {
            variant: "link",
            text: m,
            transform: "uppercase",
            medium: !0,
            lineClamp: 1,
            condensed: !0
          }
        ),
        /* @__PURE__ */ n(i, { spacing: "md", children: [
          /* @__PURE__ */ e(s, { href: t.href, target: t.target, children: /* @__PURE__ */ e(f, { type: "h3", text: l, ref: o, lineClamp: 2 }) }),
          /* @__PURE__ */ e(c, { text: p, lineClamp: 3, condensed: !0 })
        ] }),
        /* @__PURE__ */ e(
          g,
          {
            text: t.text,
            href: t.href,
            target: t.target,
            variant: "outline",
            fullWidth: !0
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ n(
      i,
      {
        direction: "row",
        wrap: "nowrap",
        className: a.contentWrapper,
        visibleFrom: "sm",
        spacing: "md",
        children: [
          r && /* @__PURE__ */ e(s, { href: t.href, target: t.target, children: /* @__PURE__ */ e(
            u,
            {
              ...r,
              caption: void 0,
              byline: void 0,
              orientation: "landscape",
              shadow: !0,
              className: a.image,
              mod: { variant: h },
              sizes: "260px"
            }
          ) }),
          /* @__PURE__ */ n(
            i,
            {
              direction: "column",
              spacing: "lg",
              justify: "space-between",
              className: a.textContent,
              mod: { "with-image": !!r, variant: h },
              children: [
                /* @__PURE__ */ e(
                  c,
                  {
                    variant: "primary",
                    text: m,
                    transform: "uppercase",
                    medium: !0,
                    lineClamp: 1,
                    condensed: !0
                  }
                ),
                /* @__PURE__ */ n(i, { direction: "column", spacing: "md", children: [
                  /* @__PURE__ */ e(s, { href: t.href, target: t.target, children: /* @__PURE__ */ e(f, { type: "h3", text: l, ref: o, lineClamp: 2 }) }),
                  /* @__PURE__ */ e(c, { text: p, lineClamp: y, condensed: !0 })
                ] }),
                /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(g, { text: t.text, href: t.href, variant: "outline" }) })
              ]
            }
          )
        ]
      }
    )
  ] }) });
});
d.displayName = "Spotbox";
const G = P({
  Component: R(d),
  deliveryApiParser: F
});
G.displayName = d.displayName;
export {
  a as S,
  d as _Spotbox,
  G as default
};
